var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('country-flag',_vm._b({class:{ 'no-flag': _vm.countryCode === 'XXX' },attrs:{"country":_vm.countryCode,"data-test-id":"country-flag"}},'country-flag',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }